import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function Snowflake ({className}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        display: 'block'
      }}
      className={className}
      viewBox='0 0 100 100'>
      <g
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2.3'>
        <g stroke='#649DFF'>
          <path d='M34 20a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM65.5 38a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM65.5 74a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM2.5 38a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM2.5 74a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM34 92a6 6 0 1 1 12 0 6 6 0 0 1-12 0zM40 26v18M40 68v18M13.761 41.456l10.496 5.817M55.743 64.727l10.496 5.817M66.239 41.456l-10.496 5.817M24.257 64.727L13.76 70.544' />
        </g>
        <g stroke='#274BC8'>
          <path d='M23.5 56.5l-2.057 2.832L23.5 56.5l-3.329-1.082L23.5 56.5V53v3.5l3.329-1.082L23.5 56.5l2.057 2.832zM34.5 56.5l-2.057 2.832L34.5 56.5l-3.329-1.082L34.5 56.5V53v3.5l3.329-1.082L34.5 56.5l2.057 2.832zM45.5 56.5l-2.057 2.832L45.5 56.5l-3.329-1.082L45.5 56.5V53v3.5l3.329-1.082L45.5 56.5l2.057 2.832zM56.5 56.5l-2.057 2.832L56.5 56.5l-3.329-1.082L56.5 56.5V53v3.5l3.329-1.082L56.5 56.5l2.057 2.832z' />
        </g>
      </g>
    </SvgIcon>
  )
}
